import {useInfiniteQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

import {useHostName} from 'presentation/hooks';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {useDebounce} from 'presentation/pages/private/hooks/useDebounce';
import {getServicePoints} from '../../services/getServicePoints';
import {DS_ORIGIN} from '../../constants/dsOrigin';

export function useServicePointsQuery() {
	const {SEARCH_PARAMS} = useQueryParams();
	const {ufCode, query} = SEARCH_PARAMS;
	const debouncedSearch = useDebounce({value: query, delay: 300});
	const {
		dataHostNameState: {product},
	} = useHostName();

	const params = {
		...(ufCode && {uf: ufCode}),
		...(debouncedSearch && {texto: debouncedSearch}),
		origem: DS_ORIGIN[product],
		size: 10,
	};

	const {
		data: infiniteData,
		isLoading,
		isFetching,
		isFetchingNextPage,
		fetchNextPage,
		hasNextPage,
		isError,
		refetch,
	} = useInfiniteQuery({
		queryKey: [QUERY_KEYS.SERVICE_POINTS_ADDRESSES, params],
		queryFn: async ({pageParam, signal}) =>
			getServicePoints({...params, page: pageParam, signal}),
		initialPageParam: 0,
		getNextPageParam: lastPage => {
			if (!lastPage?.paginacao || lastPage.paginacao.ultimaPagina) {
				return undefined;
			}

			return lastPage.paginacao.paginaAtual + 1;
		},
		retry: 1,
	});

	const servicePoints = infiniteData?.pages.flatMap(page => page.canaisAtendimento) ?? [];

	const loadMore = () => {
		if (hasNextPage && !isFetchingNextPage) {
			fetchNextPage();
		}
	};

	return {
		data: servicePoints,
		isLoading,
		isFetching,
		isFetchingNextPage,
		fetchNextPage,
		hasNextPage,
		isError,
		refetch,
		loadMore,
	};
}
